import styled from "styled-components";

export const ChevronRotatePositioner = styled.div<{ $panelOpen: boolean }>`
    transition: transform 0.3s ease;
    transform: ${({ $panelOpen }) => ($panelOpen ? "rotate(180deg)" : "rotate(0deg)")};
    transform-origin: center;
    display: inline-flex;
`;
